import { createRouter, createWebHistory } from "vue-router";
import index from "../layouts/index.vue";

const routes = [
  {
    path: "/",
    name: "index",
    component: index,
    children: [
      {
        path: "/",
        name: "Home",
        component: () => import("../views/ModernHome"),
      },
      {
        path: "/services",
        name: "Services",
        component: () => import("../views/ModernServices"),
      },
      {
        path: "/next-home",
        name: "ModernHome",
        component: () => import("../views/ModernHome"),
      },
      {
        path: "/next-services",
        name: "ModernServices",
        component: () => import("../views/ModernServices"),
      },
      {
        path: "/about",
        name: "About",
        component: () => import("../views/ModernAbout"),
      },
      {
        path: "/next-about",
        name: "ModernAbout",
        component: () => import("../views/ModernAbout"),
      },
      {
        path: "/Contact",
        name: "Contact",
        component: () => import("../views/ModernContact"),
      },
      {
        path: "/next-contact",
        name: "ModernContact",
        component: () => import("../views/ModernContact"),
      },
      {
        path: "/gamedev",
        name: "GameDev",
        component: () => import("../views/ModernGameDev"),
      },
      {
        path: "/auth/login",
        name: "login",
        component: () => import("../layouts/auth"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
